/**
 * Task sets are refused on a project linked to Sage Intacct: a set's edit and
 * delete call Sage inside one transaction, so a failure part way would leave the
 * two disagreeing. The backend enforces it; this lets the scoping page withhold
 * its create links.
 */

/** The part of a project the check reads: its Sage project, when it has one. */
export interface SageLinkProject {
	readonly sageProject?: {readonly sageProjectId?: string | null} | null;
}

/** Whether the project is linked to Sage Intacct, and so refuses task sets. */
export const isSageLinked = (project: SageLinkProject | null | undefined): boolean => !!project?.sageProject?.sageProjectId;
